// extracted by mini-css-extract-plugin
export default {"inner":"nPsSr","arrowIcon":"LpY0c","userIcon":"Ki9_m","text":"Z0Zfk","caption":"vs4Hx","menu":"uqZ73","menuItem":"i56oL"};